import { Component } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RouterOutlet } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [
    NgxDatatableModule,
    RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
 }
